import { createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "min-h-screen",
  "data-theme": "green"
}
const _hoisted_2 = { class: "max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "bg-white rounded-xl shadow-sm border border-gray-200 p-6" }
const _hoisted_5 = { class: "flex items-center gap-3 mb-6" }
const _hoisted_6 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800" }
const _hoisted_7 = { class: "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-blue-100 text-blue-800" }
const _hoisted_8 = { class: "grid grid-cols-2 sm:grid-cols-3 gap-6 mb-6" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "text-xs text-gray-500 uppercase tracking-wide" }
const _hoisted_11 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_12 = { class: "text-sm font-normal text-gray-500" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "text-xs text-gray-500 uppercase tracking-wide" }
const _hoisted_15 = { class: "text-xl font-bold text-gray-900" }
const _hoisted_16 = { class: "text-sm font-normal text-gray-500" }
const _hoisted_17 = { class: "text-xs text-gray-500 uppercase tracking-wide" }
const _hoisted_18 = {
  key: 1,
  class: "text-lg font-bold text-gray-900"
}
const _hoisted_19 = ["href"]
const _hoisted_20 = {
  key: 0,
  class: "mb-6 rounded-lg border border-gray-200 overflow-hidden map-container"
}
const _hoisted_21 = {
  ref: "mapContainer",
  style: {"height":"300px","width":"100%"}
}
const _hoisted_22 = { class: "flex gap-3 mb-6" }
const _hoisted_23 = {
  key: 1,
  href: "/users/sign_up",
  class: "px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition inline-block"
}
const _hoisted_24 = { class: "text-sm font-semibold text-gray-900 mb-3" }
const _hoisted_25 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_26 = { class: "inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-sm font-medium text-blue-800 shrink-0" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 1,
  class: "text-sm text-gray-900"
}
const _hoisted_29 = ["href"]
const _hoisted_30 = {
  key: 1,
  class: "text-sm text-gray-400"
}
const _hoisted_31 = { class: "mt-6 pt-6 border-t border-gray-200" }
const _hoisted_32 = { class: "flex gap-1 mb-4" }
const _hoisted_33 = {
  key: 0,
  class: "space-y-4 mb-6"
}
const _hoisted_34 = { class: "inline-flex items-center justify-center w-8 h-8 rounded-full bg-blue-100 text-sm font-medium text-blue-800 shrink-0 mt-0.5" }
const _hoisted_35 = { class: "flex-1" }
const _hoisted_36 = { class: "flex items-center gap-2" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "text-sm font-medium text-gray-900"
}
const _hoisted_39 = { class: "text-xs text-gray-400" }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "text-sm text-gray-700 mt-0.5" }
const _hoisted_42 = {
  key: 1,
  class: "text-sm text-gray-400 mb-4"
}
const _hoisted_43 = { key: 2 }
const _hoisted_44 = ["placeholder"]
const _hoisted_45 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavBar"], {
      "signed-in": $props.signedIn,
      "user-name": $props.userName,
      "active-page": "shared_runs"
    }, null, 8 /* PROPS */, ["signed-in", "user-name"]),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" Flash "),
      ($setup.flash)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(['mb-4 px-4 py-3 rounded-lg text-sm', $setup.flash.type === 'success' ? 'bg-blue-100 text-blue-800' : 'bg-red-100 text-red-800'])
          }, _toDisplayString($setup.flash.message), 3 /* TEXT, CLASS */))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Back link "),
      _createElementVNode("a", {
        href: $setup.locale === 'ru' ? '/ru/shared_runs' : '/shared_runs',
        class: "text-sm text-blue-700 hover:text-blue-900 mb-6 inline-block"
      }, "← " + _toDisplayString($setup.t('shared_runs.back_to_list')), 9 /* TEXT, PROPS */, _hoisted_3),
      _createCommentVNode(" Run details card "),
      _createElementVNode("div", _hoisted_4, [
        _createCommentVNode(" Date & time "),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString($setup.formatDate($setup.run.date)), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_7, _toDisplayString($setup.formatTime($setup.run.date)), 1 /* TEXT */)
        ]),
        _createCommentVNode(" Stats "),
        _createElementVNode("div", _hoisted_8, [
          ($setup.run.distance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, _toDisplayString($setup.t('shared_runs.distance')), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_11, [
                  _createTextVNode(_toDisplayString($setup.run.distance) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_12, _toDisplayString($setup.t('shared_runs.km')), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          ($setup.run.pace)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString($setup.t('shared_runs.pace')), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_15, [
                  _createTextVNode(_toDisplayString($setup.run.pace) + " ", 1 /* TEXT */),
                  _createElementVNode("span", _hoisted_16, _toDisplayString($setup.t('shared_runs.min_km')), 1 /* TEXT */)
                ])
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_17, _toDisplayString($setup.t('shared_runs.organizer')), 1 /* TEXT */),
            ($props.signedIn && $setup.run.organizer.id !== $props.userId)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = $event => ($setup.openChatWith($setup.run.organizer))),
                  class: "text-lg font-bold text-gray-900 hover:text-blue-700 cursor-pointer"
                }, _toDisplayString($setup.run.organizer.name), 1 /* TEXT */))
              : (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString($setup.run.organizer.name), 1 /* TEXT */)),
            _createCommentVNode(" Organizer toggle phone "),
            ($setup.run.organizer.id === $props.userId && $setup.run.organizer_has_phone)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  onClick: $setup.toggleOrganizerPhone,
                  class: _normalizeClass(['mt-1 text-xs cursor-pointer', $setup.run.phone_visible ? 'text-blue-700' : 'text-gray-400'])
                }, _toDisplayString($setup.run.phone_visible ? $setup.t('shared_runs.phone_shown') : $setup.t('shared_runs.phone_hidden')), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true),
            _createCommentVNode(" Participant sees organizer phone "),
            ($setup.run.organizer.id !== $props.userId && $setup.run.organizer.phone && $setup.isParticipant)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 3,
                  href: 'tel:' + $setup.run.organizer.phone,
                  class: "mt-1 inline-flex items-center gap-1 text-xs text-blue-700 hover:text-blue-900"
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("svg", {
                    class: "w-3 h-3",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      "stroke-width": "2",
                      d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    })
                  ], -1 /* CACHED */)),
                  _createTextVNode(" " + _toDisplayString($setup.run.organizer.phone), 1 /* TEXT */)
                ], 8 /* PROPS */, _hoisted_19))
              : _createCommentVNode("v-if", true)
          ])
        ]),
        _createCommentVNode(" Map "),
        ($setup.run.latitude && $setup.run.longitude)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, null, 512 /* NEED_PATCH */)
            ]))
          : _createCommentVNode("v-if", true),
        _createCommentVNode(" Actions "),
        _createElementVNode("div", _hoisted_22, [
          (!$setup.isPast)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                ($props.signedIn)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (!$setup.isParticipant && $setup.run.organizer.id !== $props.userId)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: $setup.joinRun,
                            class: "px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition"
                          }, _toDisplayString($setup.t('shared_runs.join')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true),
                      ($setup.isParticipant)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: $setup.leaveRun,
                            class: "px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition"
                          }, _toDisplayString($setup.t('shared_runs.leave')), 1 /* TEXT */))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  : (_openBlock(), _createElementBlock("a", _hoisted_23, _toDisplayString($setup.t('shared_runs.register_to_participate')), 1 /* TEXT */))
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ]),
        _createCommentVNode(" Participants "),
        _createElementVNode("div", null, [
          _createElementVNode("h3", _hoisted_24, _toDisplayString($setup.t('shared_runs.participants')) + " (" + _toDisplayString($setup.run.participants.length) + ")", 1 /* TEXT */),
          ($setup.run.participants.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.run.participants, (p) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: p.id,
                    class: "flex items-center gap-3 py-2 border-b border-gray-100 last:border-0"
                  }, [
                    _createElementVNode("span", _hoisted_26, _toDisplayString((p.first_name || p.name).charAt(0).toUpperCase()), 1 /* TEXT */),
                    ($props.signedIn && p.id !== $props.userId)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          onClick: $event => ($setup.openChatWith({ id: p.id, name: p.name })),
                          class: "text-sm text-gray-900 hover:text-blue-700 cursor-pointer"
                        }, _toDisplayString(p.name), 9 /* TEXT, PROPS */, _hoisted_27))
                      : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(p.name), 1 /* TEXT */)),
                    _createCommentVNode(" Participant toggles own phone "),
                    (p.id === $props.userId && p.has_phone)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 2,
                          onClick: $setup.toggleParticipantPhone,
                          class: _normalizeClass(['text-xs cursor-pointer', p.phone_visible ? 'text-blue-700' : 'text-gray-400'])
                        }, _toDisplayString(p.phone_visible ? $setup.t('shared_runs.phone_shown') : $setup.t('shared_runs.phone_hidden')), 3 /* TEXT, CLASS */))
                      : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Organizer sees phone if consented "),
                    (p.phone && $setup.run.organizer.id === $props.userId)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 3,
                          href: 'tel:' + p.phone,
                          class: "inline-flex items-center gap-1 text-xs text-blue-700 hover:text-blue-900"
                        }, [
                          _cache[5] || (_cache[5] = _createElementVNode("svg", {
                            class: "w-3 h-3",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            })
                          ], -1 /* CACHED */)),
                          _createTextVNode(" " + _toDisplayString(p.phone), 1 /* TEXT */)
                        ], 8 /* PROPS */, _hoisted_29))
                      : _createCommentVNode("v-if", true)
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_30, _toDisplayString($setup.t('shared_runs.no_participants')), 1 /* TEXT */))
        ]),
        _createCommentVNode(" Comments "),
        _createElementVNode("div", _hoisted_31, [
          _createCommentVNode(" Tabs "),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = $event => ($setup.commentTab = 'public')),
              class: _normalizeClass(['px-4 py-2 text-sm font-medium rounded-lg transition', $setup.commentTab === 'public' ? 'bg-blue-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'])
            }, _toDisplayString($setup.t('shared_runs.public_comments')) + " (" + _toDisplayString($setup.publicComments.length) + ") ", 3 /* TEXT, CLASS */),
            ($setup.isParticipantOrOrganizer)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[2] || (_cache[2] = $event => ($setup.commentTab = 'private')),
                  class: _normalizeClass(['px-4 py-2 text-sm font-medium rounded-lg transition', $setup.commentTab === 'private' ? 'bg-blue-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'])
                }, _toDisplayString($setup.t('shared_runs.private_comments')) + " (" + _toDisplayString($setup.privateComments.length) + ") ", 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true)
          ]),
          _createCommentVNode(" Comment list "),
          ($setup.activeComments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.activeComments, (c) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: c.id,
                    class: "flex gap-3"
                  }, [
                    _createElementVNode("span", _hoisted_34, _toDisplayString(c.user.name.charAt(0).toUpperCase()), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_35, [
                      _createElementVNode("div", _hoisted_36, [
                        ($props.signedIn && c.user.id !== $props.userId)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              onClick: $event => ($setup.openChatWith(c.user)),
                              class: "text-sm font-medium text-gray-900 hover:text-blue-700 cursor-pointer"
                            }, _toDisplayString(c.user.name), 9 /* TEXT, PROPS */, _hoisted_37))
                          : (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(c.user.name), 1 /* TEXT */)),
                        _createElementVNode("span", _hoisted_39, _toDisplayString($setup.formatCommentDate(c.created_at)), 1 /* TEXT */),
                        (c.user.id === $props.userId || $props.userAdmin)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              onClick: $event => ($setup.deleteComment(c.id)),
                              class: "text-xs text-red-400 hover:text-red-600 cursor-pointer ml-auto"
                            }, _toDisplayString($setup.t('shared_runs.delete')), 9 /* TEXT, PROPS */, _hoisted_40))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _createElementVNode("p", _hoisted_41, _toDisplayString(c.body), 1 /* TEXT */)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_42, _toDisplayString($setup.t('shared_runs.no_comments')), 1 /* TEXT */)),
          _createCommentVNode(" Add comment form "),
          ($props.signedIn && ($setup.commentTab === 'public' || $setup.isParticipantOrOrganizer))
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("form", {
                  onSubmit: _withModifiers($setup.addComment, ["prevent"]),
                  class: "flex gap-3"
                }, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($setup.newComment) = $event)),
                    type: "text",
                    placeholder: $setup.t('shared_runs.add_comment'),
                    class: "flex-1 px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  }, null, 8 /* PROPS */, _hoisted_44), [
                    [_vModelText, $setup.newComment]
                  ]),
                  _createElementVNode("button", {
                    type: "submit",
                    disabled: !$setup.newComment.trim(),
                    class: "px-4 py-2 text-sm font-medium text-white bg-blue-700 rounded-lg hover:bg-blue-800 transition disabled:opacity-50 cursor-pointer"
                  }, _toDisplayString($setup.t('shared_runs.send')), 9 /* TEXT, PROPS */, _hoisted_45)
                ], 32 /* NEED_HYDRATION */)
              ]))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ])
  ]))
}